<template>
  <div>
    <RwvMenu />
    <div id="app">
      <div>
        <h3 class="PageHeader">Pharmacies</h3>
        <input type="text" v-model="searchValue" placeholder="Search Pharmacies" id="search-input"> <br />
        <table class="Pharmacy-table DisplayTable">
          <thead>
              <tr v-if="editingId != null">
                <th>Pharmacy</th>
                <th>Region</th>
                <th>Enabled</th>
                <th class="buttonCol"/>
              </tr>
              <tr v-else>
                <th v-if="currentSort == 'code'"
                  @click ="sort('code')"
                  :class="currentSortDir == 'asc' ? 'ReportsAscIcon' :'ReportsDescIcon'">
                  Pharmacy
                </th>
                <th v-else
                  @click ="sort('code')"
                  class="ReportsDisabledIcon">
                  Pharmacy
                </th>
                <th v-if="currentSort == 'region'"
                  @click ="sort('region')"
                  :class="currentSortDir == 'asc' ? 'ReportsAscIcon' :'ReportsDescIcon'">
                  Region
                </th>
                <th v-else
                  @click ="sort('region')"
                  class="ReportsDisabledIcon">
                  Region
                </th>
                <th class="enabledCol">Enabled</th>
                <th class="buttonCol"/>
              </tr>
            </thead>
            <tbody>
              <tr height="30px">
                <td class="Pharmacy-table-cell">
                  <input
                    v-model="code"
                    type="text"
                    placeholder="Pharmacy Code"
                    @change="checkDuplicate(code, 'new')"
                    class="PharmacyDescription">
                </td>
                <td class="Pharmacy-table-cell">
                  <input type="text">
                </td>
                <td class="Pharmacy-table-cell">
                  <input
                    v-model="enabled"
                    type="checkbox"
                    readonly="readonly">
                </td>
                <td v-if="editingId != null" class="Pharmacy-table-cell" >
                  <button class="addrecordbutton icon btnDisabled" hidden></button>
                </td>
                <td v-else-if="PharmacyValid && editingId === null" class="product-table-cell center" >
                  <button v-on:click="createPharmacy(code, enabled)" class="addrecordbutton icon" title="Add Pharmacy"></button>
                </td>
                <td v-else class="Pharmacy-table-cell">
                  <button class="addrecordbutton icon btnDisabled" title="Not all data has been entered to add record" disabled></button>
                </td>
              </tr>
              <tr v-for= "(Pharmacy, indexPharmacy) in sortedPharmacies" :key="indexPharmacy" height="30px" data-is-editable="0">
                <td class="Pharmacy-table-cell" >
                  <input type="text"
                    v-model="Pharmacy.code"
                    :readonly="editingId == indexPharmacy ? false : true"
                    :class="editingId == indexPharmacy ? 'PharmacyDescription editable' :'PharmacyDescription'"
                    @change="checkDuplicate(Pharmacy.code, 'update')">
                </td>
                <td class="Pharmacy-table-cell" >
                  <input type="text"
                    :readonly="editingId == indexPharmacy ? false : true"
                    :class="editingId == indexPharmacy ? 'editable' :''"
                  >
                </td>
                <td class="Pharmacy-table-cell">
                  <input type="checkbox"
                    v-model="Pharmacy.enabled"
                    :disabled="editingId == indexPharmacy ? false : true"
                    :class="editingId == indexPharmacy ? 'editable' :''" >
                </td>
                <td class="Pharmacy-table-cell">
                    <span  v-if="editingId === null">
                      <button v-on:click="editItem(indexPharmacy)" class="editbutton icon" title="Edit Pharmacy"></button>
                      <button v-on:click="deletePharmacy(Pharmacy.id, Pharmacy.code, indexPharmacy)" class="deletebutton icon" title="Delete Pharmacy"></button>
                    </span>
                    <span v-else-if="editingId === indexPharmacy">
                      <span v-if="!PharmacyValid">
                        <button disabled class="savebutton icon btnDisabled" title="Not all data has been entered to save record"></button>
                      </span>
                      <span v-else>
                        <button v-on:click="updatePharmacy(Pharmacy.id, Pharmacy.code, Pharmacy.enabled)" class="savebutton icon" title="Save"></button>
                      </span>
                        <button v-on:click="canceledit()" class="cancelbutton icon" title="Cancel"></button>
                    </span>
                    <span v-else>
                      <button class="editbutton icon" hidden></button>
                      <button class="deletebutton icon" hidden></button>
                    </span>
                  </td>
              </tr>
            </tbody>
        </table>
    </div>

      <div v-if="message" class="errormessage">
        <table>
          <tr>
            <td>{{message}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import { listPharmacys } from '../graphql/queries';
import { getPharmacyByCode } from '../graphql/queries';
import { createPharmacy } from '../graphql/mutations';
import { updatePharmacy } from '../graphql/mutations';
import { deletePharmacy } from '../graphql/mutations';
import { onCreatePharmacy } from '../graphql/subscriptions';
import RwvMenu from "@/components/TheMenu";
import commonFunctions from "@/components/commonFunctions";

export default {
  name: 'app',
  props: ['prods'],
  components:{
  RwvMenu,
  },
  async created() {
//   console.log('created ...');
    this.getPharmacys();
    this.subscribeCreate();
    },
    data() {
      return {
        Pharmacys: [],
        frozenPharmacies: [],
        editingId: null,
        code: '',
        enabled: true,
        id:'',
        message: '',
        Duplicate: [],
        dupCode: '',
        AllData: false,
        PharmacyValid: false,
        currentSort: 'code',
        currentSortDir: 'asc',
        Vaccinations: [],
        searchValue: '',
      }
  },
  computed: {
    sortedPharmacies: function() {
      // console.log('sortedPharmacies ...');
      if (this.editingId != null){return this.frozenPharmacies}
      return this.searchPharmacies.slice().sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        if(a[this.currentSort] === null | a[this.currentSort] === undefined) return 1 * modifier;
        if(b[this.currentSort] === null | b[this.currentSort] === undefined) return -1 * modifier;
        if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
      },
    searchPharmacies() {
      let tempPharmacies = this.Pharmacys
      
      if (this.searchValue != '' && this.searchValue) {
            tempPharmacies = tempPharmacies.filter((item) => {
              return item.code
                .toUpperCase()
                .includes(this.searchValue.toUpperCase())
            })
          }
      return tempPharmacies
    }
  },
  watch: {
    sortedPharmacies: {
      handler: function() {
        if (this.editingId === null) {
          this.frozenPharmacies = this.sortedPharmacies.slice()
        }
      }     
    }
  },
  methods: {
    reset(){
//      Object.assign(this.$data, this.$options.data.apply(this));
      this.getPharmacys();
    },

    async getPharmacys() {
//       console.log('getPharmacys ...');
      var limit = 1000;
      try {
        const Pharmacys = await API.graphql({
          query: listPharmacys,
          variables: {limit: limit}
        });
        this.Pharmacys = Pharmacys.data.listPharmacys.items;
      }
      catch (error) {
        console.log(error)
        this.message = commonFunctions.displayError(error);
      }
//       console.log('getPharmacys end ...');
    },
                                                                // Create Pharmacy
    async createPharmacy(cde, enabled) {
      // console.log('createPharmacy ...');
      if (!cde) return;
      if (!commonFunctions.xssTest(cde)) {
        this.message = commonFunctions.xssMessage("Pharmacy")
        return
      }
      enabled = "true"
      let code = cde.trim()

      const CreateValues = { code, enabled };
      // console.log('Pharmacy =', CreateValues);
      try {
        await API.graphql({
          query: createPharmacy,
          variables: {input: CreateValues},
        });
                                                                  // Reset variables
        this.resetVariables();
      }
      catch (error) {
        console.log(error)
        this.message = commonFunctions.displayError(error);
      }
      // console.log('createPharmacys end ...');
    },
                                                                        // Update view on create
    subscribeCreate () {
      API.graphql({
      query: onCreatePharmacy
      })
      .subscribe ({
        next: (items) => {
        const pharmacy = items.value.data.onCreatePharmacy;
        if (this.Pharmacys.some(item => item.name === pharmacy.code)) return; // remove duplications
        this.Pharmacys = [...this.Pharmacys, pharmacy];
      }
      })
    },
                                                                          // Check for duplicates
    async checkDuplicate(code,Updatetype) {
      // console.log('checkDuplicate ...');
      this.message = ''
      if (!commonFunctions.xssTest(code)) {
        this.message = commonFunctions.xssMessage("Pharmacy")
        this.PharmacyValid=false
        return
      }
      try {
        if(code != ''){
        // console.log('not null');
        this.PharmacyValid = true;
        if (Updatetype === "new"){this.code = code}
        if (Updatetype != "new" && this.Pharmacys[this.editingId].code ===this.dupCode){
          return
        }
        const QueryVariables = {code};
        const RecordToTest = await API.graphql({
          query: getPharmacyByCode,
          variables: QueryVariables,
          });
        this.Duplicate = RecordToTest.data.getPharmacyByCode.items;
        if (this.Duplicate[0]){
          this.message = "Duplicate Pharmacy Code entered";
          this.PharmacyValid = false;
          return;
        }
        }
        else{this.PharmacyValid = false;}
      }
      catch (error) {
        console.log(error)
        this.PharmacyValid = false;
        this.message = commonFunctions.displayError(error);
      }
       //console.log('checkDuplicate end');
    },

      allDataEntered(code){
           // console.log ("allDataEntered ...");
         if (!commonFunctions.xssTest(code)) {
           this.message = commonFunctions.xssMessage("Pharmacy")
           this.AllData = false;
           return
         }
        if (!code){
          this.AllData = false;}
        else {
          this.AllData = true;}
        //   console.log ("allDataEntered end");
        },
                                                              // Update Pharmacy
    async updatePharmacy(id, cde, enabled) {
      // console.log('updatePharmacy ...');
      if (!cde) return;
      if (!commonFunctions.xssTest(cde)) {
        this.message = commonFunctions.xssMessage("Pharmacy")
        return
      }
      try{
        let code = cde.trim()
        const UpdateValues = { id, code, enabled };
        await API.graphql({
          query: updatePharmacy,
          variables: {input: UpdateValues},
        });
        this.editingId = null;
        this.$forceUpdate();
      }
      catch (error) {
        console.log(error)
        this.PharmacyValid = false;
        this.message = commonFunctions.displayError(error);
      }
      // console.log('updatePharmacy end ...');
    },
                                                                // Delete Pharmacy
    async deletePharmacy(id, code, indexRow) {
      // console.log('deletePharmacy ...');
      if(confirm("Do you really want to delete Pharmacy (" + code + ")?")) {
                                                                // check if any vaccinations recorded for the pharmacy
        try {
          var toDate = new Date(2021, 5, 1)
          var fromDate = new Date(2099, 12, 31, 23, 59, 59)
          const Vaccination = await commonFunctions.getVaccinationsPharmacy(code, toDate, fromDate)
          if (Vaccination[0]){
            this.message = "Vaccination records exist for this pharmacy. It can't be deleted. It can be disabled";
            return;
          }
          const Pharmacy = {id};
          await API.graphql({
            query: deletePharmacy,
            variables: {input: Pharmacy},
          });
          this.Pharmacys.splice(indexRow, 1);
        }
        catch (error) {
          console.log(error)
          this.PharmacyValid = false;
          this.message = commonFunctions.displayError(error);
        }
      }
      // console.log('deletePharmacy end ...');
    },

                                                              // set row in edit mode
    editItem(indexRow) {
      // console.log('editItem ...');
      this.editingId = indexRow
      this.resetVariables();
      this.dupCode = this.Pharmacys[this.editingId].code
      this.AllData = true;
      this.PharmacyValid = true;
    },
                                                                // Reset row to original values
    canceledit() {
      // console.log('Cancel Edit ...');
      this.resetVariables();
      this.editingId = null;
      this.reset();
      // console.log('Cancel Edit end');
    },
    resetVariables() {
      // console.log('reset variables ...');
      this.code = '';
      this.PharmacyValid = false;
      this.AllData = false;
      this.message = '';
      // console.log('reset variables end');
    },
    sort: function(s) {
      // console.log('sort ...');
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
      // console.log('sort end');
    },

}
}
</script>
<style>

</style>
